import { Box, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { Equipment } from "../../../types/equipments";

interface EquipmentConfigurationChipsProps {
  attributeValues?: Equipment["attribute_values"];
}

/** An equipment's configuration as "Attribute: choice (note)" chips. */
export const EquipmentConfigurationChips = ({ attributeValues }: EquipmentConfigurationChipsProps) => {
  const { t } = useTranslation();
  const values = Array.isArray(attributeValues) ? attributeValues : [];

  if (values.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: "text.secondary", fontStyle: "italic" }}>
        {t("No configuration")}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {values.map((value, index) => {
        const attrName = value.attribute_info?.name;
        const choiceName = value.choice_info?.name;
        const note = value.note?.trim();
        const base =
          attrName && choiceName
            ? `${attrName}: ${choiceName}`
            : choiceName || (value.choice != null ? String(value.choice) : "—");
        const label = note ? `${base} (${note})` : base;
        return (
          <Chip key={`${value.id || value.choice}-${index}`} label={label} size="small" variant="outlined" />
        );
      })}
    </Box>
  );
};
